import * as React from 'react';

function SvgLayout(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path
        d="M8 0H2a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V2a2 2 0 00-2-2zm14 0h-6a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V2a2 2 0 00-2-2zM8 14H2a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2v-6a2 2 0 00-2-2zm14 0h-6a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2v-6a2 2 0 00-2-2z"
        fillRule="evenodd"
      />
    </svg>
  );
}

const MemoSvgLayout = React.memo(SvgLayout);
export default MemoSvgLayout;
